/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  DigitalPaymentSuccessResponse,
  ErrorMessage,
  SplitAndPayDigitalBillDtoV2,
} from '../models';
import {
    DigitalPaymentSuccessResponseFromJSON,
    DigitalPaymentSuccessResponseToJSON,
    ErrorMessageFromJSON,
    ErrorMessageToJSON,
    SplitAndPayDigitalBillDtoV2FromJSON,
    SplitAndPayDigitalBillDtoV2ToJSON,
} from '../models';

export interface SplitAndPayV5Request {
    locationId: string;
    reference: string;
    splitAndPayDigitalBillDtoV2: SplitAndPayDigitalBillDtoV2;
}

/**
 * 
 */
export class PayDigitalBillControllerApi extends runtime.BaseAPI {

    /**
     */
    async splitAndPayV5Raw(requestParameters: SplitAndPayV5Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DigitalPaymentSuccessResponse>> {
        if (requestParameters.locationId === null || requestParameters.locationId === undefined) {
            throw new runtime.RequiredError('locationId','Required parameter requestParameters.locationId was null or undefined when calling splitAndPayV5.');
        }

        if (requestParameters.reference === null || requestParameters.reference === undefined) {
            throw new runtime.RequiredError('reference','Required parameter requestParameters.reference was null or undefined when calling splitAndPayV5.');
        }

        if (requestParameters.splitAndPayDigitalBillDtoV2 === null || requestParameters.splitAndPayDigitalBillDtoV2 === undefined) {
            throw new runtime.RequiredError('splitAndPayDigitalBillDtoV2','Required parameter requestParameters.splitAndPayDigitalBillDtoV2 was null or undefined when calling splitAndPayV5.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v6/locations/{locationId}/digital-bills/{reference}/split-and-pay`.replace(`{${"locationId"}}`, encodeURIComponent(String(requestParameters.locationId))).replace(`{${"reference"}}`, encodeURIComponent(String(requestParameters.reference))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SplitAndPayDigitalBillDtoV2ToJSON(requestParameters.splitAndPayDigitalBillDtoV2),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DigitalPaymentSuccessResponseFromJSON(jsonValue));
    }

    /**
     */
    async splitAndPayV5(requestParameters: SplitAndPayV5Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DigitalPaymentSuccessResponse> {
        const response = await this.splitAndPayV5Raw(requestParameters, initOverrides);
        return await response.value();
    }

}
